import * as React from "react"
import { Link } from "react-router-dom"
import * as i18next from 'i18next'

export type HeaderProps = {
  name: string,
  company: string,
  rootpath: string,
  handleLogOut: () => void;
}

export const Header: React.StatelessComponent<HeaderProps> = ({ name, company, rootpath, handleLogOut }) => {
  return (
    <header className="header">
      <nav className="header__nav" aria-label="primary">
        <div className="header__toolbar">
          <div className="header__brand">
            <Link className="header__link" to={rootpath}>
              <span className="sr-text">{i18next.t('quotation_request:header.title')}</span>
              <svg className="header__logo" width="120" height="32" aria-hidden="true">
                <use xlinkHref="#icon--logo" />
              </svg>
            </Link>
          </div>

          <div className="menu">
            <button
              className="menu__button profile-btn"
              aria-controls="a11y-menu-collapse"
              onClick={e => document.documentElement.classList.toggle('menu--toggled')}
            >
              <span className="sr-text">{i18next.t('quotation_request:header.clickables.toggle_menu')}</span>
              <div className="profile-btn__content">
                <span className="profile-btn__text">{name}</span>
                <span className="profile-btn__text profile-btn__text--muted">{company}</span>
              </div>
              <div className="profile-btn__visual">
                <svg className="profile-btn__icon" width="20" height="22" aria-hidden="true">
                  <use xlinkHref="#icon--user" />
                </svg>
              </div>
            </button>
          </div>
        </div>

        <div id="a11y-menu-collapse" className="menu__wrapper">
          <ul className="menu__list">
            <li className="menu__item">
              <Link to={`${rootpath}/change-password`} className="menu__link" onClick={(e) => document.documentElement.classList.remove('menu--toggled')}>
                {i18next.t('quotation_request:header.clickables.change_password')}
              </Link>
            </li>
            <li className="menu__item">
              <button onClick={handleLogOut} className="menu__link">
                {i18next.t('quotation_request:header.clickables.log_out')}
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  )
}
